import {ExportsTable} from "./ExportsTable";
import React, {useState} from "react";
import {Checkbox} from "antd";

const ProjectSearchExportsTab = ({
    loading,
    exports
}) => {
  const [hideColumns, setHideColumns] = useState(true);
  const handleCheckbox = (t) => {
    setHideColumns(!t.target.checked)
  }
  return (
    <>
      <Checkbox
        style={{marginBottom: 10}}
        onChange={handleCheckbox}
        disabled={loading}
        >Display Export Data
      </Checkbox>
      <ExportsTable
        exports={exports}
        permissions={null}
        loading={loading}
        setLoading={null}
        hideColumns={hideColumns}
        editMap={null}
        setEditMap={null}
        pendingProjectCodes={null}
        notificationError={null}
        loadExports={null}
        disableExports={null}
        setSelectedExport={null}
        setShowHourLog={null}
      />
    </>
  );
}

export {ProjectSearchExportsTab};